import React, { useState, useEffect, useRef } from "react";
import ButtonContained from "components/ButtonContained";

const PopoutDropdown = ({
  label,
  options,
  align = "right",
  direction = "down",
  buttonIcon = "chevronDown",
  secondaryIcon,
  disabled,
  onOptionSelect,
  id,
  dataCy,
  fullWidth = false,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if label changes
  useEffect(() => {
    setOpen(false);
  }, [label]);
  // Ensure dropdown scrolls into view if it's near the bottom
  useEffect(() => {
    if (open && dropdownRef.current) {
      dropdownRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [open]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
      if(dropdownRef.current && dropdownRef.current === event.target) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className={`relative ${fullWidth ? "w-full" : "w-auto"}`}>
      <ButtonContained
        id={id}
        dataCy={dataCy}
        text={label}
        disabled={disabled}
        icon={buttonIcon}
        secondaryIcon={secondaryIcon}
        type="mediumOutlineIconRight"
        onClick={() => !disabled && setOpen(!open)}
        className={fullWidth ? "w-full" : ""}
      />
      {open && (
        <div
          ref={dropdownRef}
          className={`absolute ${align === "right" ? "right-0" : "left-0"}
                      ${direction === "up" ? "bottom-full mb-2" : "top-full mt-2"}
                      bg-[var(--color-white)] shadow-md rounded-md z-10 whitespace-nowrap p-5
                      max-h-72 overflow-y-auto custom-scrollbar`}
        >
          {options.map((option, index) => (
            <button
              key={index}
              id={`Popout-dropdown-option-${index + 1}-${option.name}`}
              data-cy={`Popout-dropdown-option-${index + 1}-${option.name}`}
              disabled={option.disabled}
              onClick={() => {
                if (onOptionSelect) {
                  onOptionSelect(option.value);
                  setOpen(false);
                }
              }}
              className={`tw-paragraph-reg block w-full text-left px-4 py-2 hover:bg-[var(--color-gray-100)] rounded-[8px] ${option.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              {option.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PopoutDropdown;
